export default __webpack_public_path__ + "static/react-efb72e16232803484893f3591a07b142.svg";